<template>
    <div @click="onClick(item.line1)">
        <div class="card relative mb-6 rounded-xl">
            <!-- <img :src="item.imageUrl" class="w-full max-w-full h-auto" alt /> -->
            <div class="campaign-image rounded-xl" :style="{ 'background-image': `url('${item.imageUrl}')` }"></div>
            <div
                class="label absolute -bottom-3 right-6 h-7 w-40 text-center text-base text-white py-2px"
            >{{ item.line1 }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SearchPromotionItem",
    props: {
        item: {
            type: Object
        }
    },
    methods: {
        onClick: function (cateName) {
            // if (this.item.cat == null) return
            if (this.item.line1.toLowerCase() == 'oversea') {
                this.$router.push({
                    name: 'promotion-search-campaigns',
                    params: {
                        cat: this.item.cat
                    }
                })
            } else {
                this.tracking.event('main_category', 'click_main_category', cateName, null);
                window.open(this.item.line2);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/image.scss";

.card {
    object-fit: contain;
    // box-shadow: 0 0 10px 0 rgba(23, 55, 127, 0.31);
    .label {
        background-image: url("~@/assets/button/bg.svg");
        background-size: 100%;
    }

    img {
        margin: auto;
    }

    .campaign-image {
        @include boxRatio($ratio: 33.33%);
    }
}
</style>
